var React = require('react');

function BluePlayVideoIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 9"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Home","transform":"translate(-369.000000, -2361.000000)"},React.createElement("g",{"id":"Group-9","transform":"translate(369.000000, 2361.000000)"},[React.createElement("circle",{"id":"Oval","fill":"#4163F4","cx":"22","cy":"22","r":"22","key":0}),React.createElement("polygon",{"id":"Rectangle","fill":"#FFFFFF","points":"16 16 29 22.5 16 29","key":1})])))]);
}

BluePlayVideoIcon.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 44 44","version":"1.1"};

module.exports = BluePlayVideoIcon;

BluePlayVideoIcon.default = BluePlayVideoIcon;
